


























































































































































































import Vue from 'vue';
import Button from '@/components/form/Button.vue';
import InventoryTable from '@/components/publisher/InventoryTable.vue';
import { Inventory } from '@/types/publisher/inventory';
import { PaginationData } from '@/types';
import { ColumnItems, FilterTypeField } from '@/components/table/types';
import filterParams from '@/components/table/utils/filterParameters';
import ModalWrapper from '@/components/ModalWrapper.vue';
import FieldDatePicker from '@/components/form/FieldDatePicker.vue';
import CopyToClipboard from '@/utils/CopyToClipboard';
import _ from 'lodash';

export default Vue.extend({
  name: 'Inventory',
  components: { ModalWrapper, Button, InventoryTable, FieldDatePicker },
  created() {
    const params = filterParams.getUrlFilter(this.$route.query['filter']) || {};
    if (params['from_date'] && params['to_date']) {
      this.datePeriod = [params['from_date'], params['to_date']];
    }
    this.$store.commit('changeTitle', this.$t('pages.inventory.title'));
    this.getInventory(params);
  },
  watch: {
    isConfirmedEmail(value) {
      if (!value) {
        this.addNotConfirmedEmailMessage = true;
        return;
      }
      this.addNotConfirmedEmailMessage = false;
    },
  },
  computed: {
    inventoryList(): Array<Inventory> {
      return this.$store.state.publisher.inventoryList.data.map((inventory) => {
        if (inventory.moderation_status === null) {
          inventory.moderation_status = {
            label: this.$t(
              'pages.inventory.table.body.moderationStatus.moderation'
            ),
            value: 'moderation',
          };
        }

        switch (inventory.status.value) {
          case 'active':
            inventory.status.label = this.$t('body.table.body.status.active');
            break;
          case 'draft':
            inventory.status.label = this.$t('body.table.body.status.stopped');
            break;
          default:
            break;
        }

        if (inventory.placements.length) {
          inventory.placements.forEach((placement) => {
            switch (placement.type.value) {
              case 'banner':
                placement.type.label = this.$t(
                  'body.table.body.trafficType.banner'
                );
                break;
              case 'native':
                placement.type.label = this.$t(
                  'body.table.body.trafficType.native'
                );
                break;
              case 'push':
                placement.type.label = this.$t(
                  'body.table.body.trafficType.push'
                );
                break;
              default:
                break;
            }

            switch (placement.status.value) {
              case 'active':
                placement.status.label = this.$t(
                  'body.table.body.status.active'
                );
                break;
              case 'draft':
                placement.status.label = this.$t(
                  'body.table.body.status.stopped'
                );
                break;
              default:
                break;
            }
          });
        }

        return inventory;
      });
    },
    paginationData(): PaginationData {
      return this.$store.state.publisher.inventoryList.paginationData;
    },
    getCreateInventoryRoute() {
      return '/publisher/inventory/create';
    },
    isConfirmedEmail() {
      return this.$store.state.auth.isConfirmedEmail;
    },
  },
  methods: {
    async getInventory(searchData) {
      let columns: Array<string> = [];
      this.loadData = true;
      this.searchData = searchData;
      this.columns.map((item, index) => {
        if (searchData[item.field]) {
          this.columns[index].filterValue = searchData[item.field];
        } else {
          this.columns[index].filterValue = null;
        }
      });
      if (
        !this.datePeriod.length ||
        this.datePeriod.find((i) => i === null) === null
      ) {
        this.defaultPeriod();
      }
      if (Array.isArray(this.datePeriod) && this.datePeriod.length == 2) {
        this.searchData['from_date'] = this.datePeriod[0];
        this.searchData['to_date'] = this.datePeriod[1];
      }
      if (this.searchData['sort']) {
        this.sort = this.searchData['sort'];
      }

      columns = this.columns.map((col) => col.field);
      columns.push('domain');
      columns.push('status');

      await this.$store.dispatch('publisher/inventoryList', {
        searchData,
        columns,
      });
      filterParams.toUrl({
        from_date: this.datePeriod[0],
        to_date: this.datePeriod[1],
      });
      filterParams.saveFilter();
      this.loadData = false;
    },
    defaultPeriod() {
      const from = new Date();
      const to = new Date();
      this.changePeriod([
        ('0' + to.getDate()).slice(-2) +
          '.' +
          ('0' + (to.getMonth() + 1)).slice(-2) +
          '.' +
          to.getFullYear(),
        ('0' + from.getDate()).slice(-2) +
          '.' +
          ('0' + (from.getMonth() + 1)).slice(-2) +
          '.' +
          from.getFullYear(),
      ]);
    },
    changePeriod(period) {
      this.datePeriod = period;
    },
    addPlacement(inventory) {
      this.$router.push('/publisher/placement/' + inventory.id);
    },
    deletePlacement(inventoryIndex, placementId) {
      this.$confirm({
        title: this.$t('pages.inventory.popup.titleDelete'),
        content: this.$tc('pages.inventory.popup.messageDelete', 2),
        cancelText: this.$t('body.popup.buttons.no'),
        okText: this.$t('body.popup.buttons.yes'),
      }).then(async () => {
        await this.$store.dispatch('publisher/deletePlacement', {
          inventoryIndex,
          placementId,
        });
      });
    },
    editInventory(inventory) {
      this.$router.push('/publisher/inventory/update/' + inventory.id);
    },
    deleteInventory(inventory) {
      this.$confirm({
        title: this.$t('pages.inventory.popup.titleDelete'),
        content: this.$tc('pages.inventory.popup.messageDelete', 1),
        cancelText: this.$t('body.popup.buttons.no'),
        okText: this.$t('body.popup.buttons.yes'),
      }).then(async () => {
        if (!inventory.id) {
          return;
        }
        await this.$store.dispatch('publisher/deleteInventory', {
          id: inventory.id,
        });
      });
    },
    changeInventoryStatus(inventory) {
      const formData = new FormData();
      if (inventory.status.value) {
        formData.append('status', inventory.status.value);
      }
      this.$store.dispatch('publisher/changeInventoryStatus', {
        id: inventory.id,
        formData,
      });
    },
    changePlacementStatus(placement) {
      const formData = new FormData();
      if (placement.status.value) {
        formData.append('status', placement.status.value);
      }
      this.$store.dispatch('publisher/changePlacementStatus', {
        id: placement.id,
        formData,
      });
    },
    showModal(widget, placementName) {
      this.modal = true;
      this.widget = widget;
      this.placementName = placementName;
    },
    copyPixelCode() {
      CopyToClipboard(this.widget);
    },
    sumInventory(placements, column) {
      if (placements && placements.length) {
        if (column === 'type') {
          return _.uniq(_.map(placements, 'type[label]'));
        } else if (column === 'fill_rate') {
          const avg = _.meanBy(placements, (p) => p[column]);
          if (avg) {
            return avg.toFixed(2);
          }
          return '0';
        } else if (column === 'sum_bid_price') {
          const sum = _.sumBy(placements, column);
          if (sum) {
            return '$ ' + sum.toFixed(2);
          }
          return '$ 0';
        } else if (
          column === 'count_view' ||
          column === 'count_click' ||
          column === 'count_view_real'
        ) {
          const sum = _.sumBy(placements, column);
          if (sum) {
            return sum;
          }
          return '0';
        } else if (column === 'visibility') {
          const avg = Math.floor(_.meanBy(placements, (p) => p[column]));
          if (avg) {
            return avg + '%';
          }
          return '0%';
        } else if (column === 'ctr') {
          const avg = _.meanBy(placements, (p) => p[column]);
          if (avg) {
            return avg.toFixed(2)
          }
          return '0';
        }
      }

      return '-';
    },
    createInventory() {
      this.$store.dispatch('publisher/addInventory');
      this.$router.push('/publisher/inventory/create');
    },
  },
  data() {
    return {
      searchData: {},
      datePeriod: [] as Array<string>,
      columns: [
        {
          name: this.$t('pages.inventory.table.header.id'),
          field: 'id',
          options: { width: '80px' },
          filterValue: null,
        },
        {
          name: this.$t('pages.inventory.table.header.name'),
          field: 'name',
          options: { 'font-weight': 'bold' },
          filterValue: null,
        },
        {
          name: this.$t('pages.inventory.table.header.moderation'),
          field: 'moderation_status',
          items: [
            {
              label: this.$t(
                'pages.inventory.table.body.moderationStatus.active'
              ),
              htmlLabel: `<span class="td-status td-status-active">${this.$t(
                'pages.inventory.table.body.moderationStatus.active'
              )}</span>`,
              value: 'approve',
            },
            {
              label: this.$t(
                'pages.inventory.table.body.moderationStatus.reject'
              ),
              htmlLabel: `<span class="td-status td-status-no-active">${this.$t(
                'pages.inventory.table.body.moderationStatus.reject'
              )}</span>`,
              value: 'reject',
            },
            {
              label: this.$t(
                'pages.inventory.table.body.moderationStatus.moderation'
              ),
              htmlLabel: `<span class="td-status td-status-moderation">${this.$t(
                'pages.inventory.table.body.moderationStatus.moderation'
              )}</span>`,
              value: 'moderation',
            },
          ] as Array<ColumnItems>,
          filterValue: null,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
        },
        {
          name: this.$t('pages.inventory.table.header.traffic'),
          field: 'type',
          filterValue: null,
        },
        {
          name: this.$t('pages.inventory.table.header.fillRate'),
          field: 'fill_rate',
          filterValue: null,
        },
        {
          name: this.$t('pages.inventory.table.header.revenue'),
          field: 'sum_bid_price',
          filterValue: null,
        },
        {
          name: this.$t('pages.inventory.table.header.views'),
          field: 'count_view',
          filterValue: null,
        },
        {
          name: this.$t('pages.inventory.table.header.viewsReal'),
          field: 'count_view_real',
          filterValue: null,
        },
        {
          name: this.$t('pages.inventory.table.header.visibility'),
          field: 'visibility',
          filterValue: null,
        },
        {
          name: this.$t('pages.inventory.table.header.ctr'),
          field: 'ctr',
          filterValue: null,
        },
        {
          name: this.$t('pages.inventory.table.header.clicks'),
          field: 'count_click',
          filterValue: null,
        },
        {
          name: '',
          field: 'buttons',
          options: { minWidth: '180px' },
          filterValue: null,
          useSort: false,
        },
      ],
      sort: null as string | null,
      loadData: false,
      widget: '',
      modal: false,
      placementName: '',
      addNotConfirmedEmailMessage: false,
    };
  },
});
